import React from "react";
import {
    View,
    ScrollView,
    StyleSheet,
    Platform,
    Linking,
} from "react-native";
import { Text } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { useThemeSettings } from "../../../ThemeProvider";
import CustomLinearGradient, { GRADIENT_TYPE } from "../../../components/CustomLinearGradient";
import { GradientStrokeBox } from "../../../components/GradientStrokeBox";
import { FULL_WIDTH } from "../../../shared/constants/dimension";
import getGlobalStyles from "../../../globalStyles";
import ThinkOLogo from "../../../components/ThinkoLogo";
import { useTrackScreenTime } from "../../../analytics/useTrackScreenTime";
import { ROUTES } from "../../../shared/constants/routes";
import { usePlatform } from "../../../providers/PlatformProvider";

export default function ContactUsScreen() {
    useTrackScreenTime(ROUTES.CONTACT_US)
    const { theme } = useThemeSettings();
    const { t } = useTranslation();
    const gStyles = getGlobalStyles();
    const thinkoEmail = 'admin@thinko.in';
    const { showWebVersion } = usePlatform();
    const subject = 'Hello thinkO buddy!';
    const body = '';

    const mailto = `mailto:${thinkoEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    const openEmail = () => {
        if (Platform.OS === 'web') {
            window.location.href = mailto;
        } else {
            Linking.openURL(mailto).catch(err =>
                console.error('Error opening email app', err)
            );
        }
    };
    const child = <View style={{ width: "100%", alignSelf: "stretch", padding: 12, alignItems: 'center' }}>
        {/* LOGO */}
        <ThinkOLogo size={64} />
        <Text style={[styles.text, { color: theme?.colors?.textPrimary }]}>
            {t("screens.contact.intro_greeting")}{" "}
            <Text style={[styles.highlight, { color: theme?.colors?.primary }]}>
                {t("screens.contact.intro_highlight")}
            </Text>
        </Text>

        <Text style={[styles.text, { color: theme?.colors?.textPrimary }]}>
            {t("screens.contact.intro_paragraph_1")}
        </Text>

        <Text style={[styles.text, { color: theme?.colors?.textPrimary }]}>
            {t("screens.contact.intro_paragraph_2")}
        </Text>

        <Text style={[styles.highlight, { marginTop: 16, color: theme?.colors?.primary }]}>
            {t("screens.contact.signature_intro")}{"\n"}
            <Text style={[styles.highlight, { color: theme?.colors?.primary }]}>{t("screens.contact.signature_team")} 🤸‍♂️</Text>
        </Text>

        {/* QUOTE CARD */}
        <View style={{ paddingVertical: 16 }}>
            <GradientStrokeBox wrapperStyle={{ width: FULL_WIDTH, borderRadius: 16, paddingHorizontal: showWebVersion ? 64 : 12 }} style={{ padding: 12, alignSelf: 'center' }}>
                <View style={[gStyles.centerColumn, { alignSelf: 'center' }]}>
                    <Text style={{ textAlign: 'center', color: theme?.colors?.textPrimary }}>{t("screens.contact.feedback_heading")}</Text>
                    <View style={gStyles.centerRow}>
                        <Text style={{ color: theme?.colors?.textPrimary }}>{t("screens.contact.email_label")}</Text>
                        {Platform.OS === 'web' ? <a href={mailto}>admin@thinko.in</a> :
                            <Text accessibilityRole="link" onPress={openEmail} style={[gStyles.link, { color: theme?.colors?.primary }]}>admin@thinko.in</Text>}
                    </View>
                    <View style={gStyles.centerRow}>
                        <Text style={{ color: theme?.colors?.textPrimary }}>{t("screens.contact.twitter_label")}</Text>
                        <Text accessibilityRole="link" onPress={() => window.open("https://x.com/intent/post?text=@thinkOnews", "_blank")} style={[gStyles.link, { color: theme?.colors?.primary }]}>@thinkOnews</Text>
                    </View>
                </View>
            </GradientStrokeBox>
        </View>
    </View>

    return (
        <ScrollView contentContainerStyle={{ paddingBottom: 10 }} showsVerticalScrollIndicator={Platform.OS === 'web'}>
            <CustomLinearGradient angle={180} gradientType={GRADIENT_TYPE.CARD2}>{child}</CustomLinearGradient>
        </ScrollView>
    );
}

const styles = StyleSheet.create({
    logo: {
        alignSelf: "center",
        marginBottom: 10,
    },

    text: {
        color: "#6A4A4A",
        fontSize: 14,
        lineHeight: 22,
        textAlign: "center",
        marginTop: 8,
        maxWidth: "100%",
        flexShrink: 1,
    },

    highlight: {
        color: "#B5585A",
        fontWeight: "600",
        textAlign: "center",
    },
});